import React, { useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Toolbar from "@material-ui/core/Toolbar";
import AuthButton from "../../../Buttons/AuthButton";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import "./MobileMenu.scss";
import * as ROUTES from '../../../../routes';


const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1)
  },
  input: {
    display: "none"
  },
  root: {
    display: "flex",
    height: 64
  },
  MuiPaper: {
    backgroundColor: "#013957"
  },
  drawer: {
    [theme.breakpoints.up("m")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  appBar: {
    zIndex:1199,
    left: 0,
    right: 0,
    [theme.breakpoints.up("m")]: {
      width: "100%"
    },
    backgroundColor: "#013957",
    width: "100%"
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("m")]: {
      display: "none"
    },
    backgroundColor: "#013957",
    outline: "none"
  },
  toolbar: theme.mixins.toolbar,
  toolbarStyled: {
    [theme.breakpoints.up('md')]: {
    display: 'none'}
  },
  drawerPaper: {
    width: drawerWidth,
    height: "fit-content",
    backgroundColor: "#013957"
  },
  buttonItem: {
    height: 56
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  columnList: {
    flexFlow: "column",
    width: "auto",
    backgroundColor: "#013957",
    color: "white"
  },
  itemText: {
    marginLeft: 14
  },
  dividerList: {
    marginLeft: 24,
    backgroundColor: "white",
    opacity: 0.15
  },
  buttonContainer: {
    padding: "16px 8px 32px"
  },
  buttonSign: {
    width: 192,
    height: 32,
    color: "#013957",
    borderRadius: "30px",
    border:"white"
  },
  buttonLogin: {
    width: 192,
    height: 32,
    backgroundColor: "transparent",
    borderColor: "white",
    fontSize: 16,
    borderRadius: 30,
    marginRight:0,
    marginTop: 24
  },
  buttonList: {
    justifyContent: "center"
  },
  logo: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end"
  },
  list: {
    width: 250
  },
  fullList: {
    width: "auto"
  }
}));

export default function Menu(props) {
  // Nuestro
  const [isChecked, setIsChecked] = useState(true);

  //Material ui
  const classes = useStyles();
  const [left, setState] = useState(false);

  const { container } = props;
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setIsChecked(true);
    setMobileOpen(false);
  };

  const [active, setActive] = useState(false);
  const [hit, setHit] = useState(active);

  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <List classes={{ root: classes.columnList }}>
        <ListItem classes={{ root: classes.buttonList }}>
          <div className={classes.buttonContainer}>
            
              <AuthButton direction={ROUTES.SIGNUP} variant="secondary" className={classes.buttonSign}>Regístrate</AuthButton>
           
            
              <AuthButton direction={ROUTES.SIGNIN} variant="primary" className={classes.buttonLogin}>Inicia Sesións</AuthButton>
            
          </div>
        </ListItem>
      </List>
    </div>
  );

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar classes={{root:classes.toolbarStyled}}>
          <button
            className={`${classes.menuButton} hamburger hamburger--arrow btn  ${
              isChecked ? true : "is-active"
            }`}
            type="button"
            onClick={() => {
              setIsChecked(!isChecked);
              if (!left) {
                setState(true);
                setMobileOpen(!mobileOpen);
              } else {
                setState(false);
                setMobileOpen(!mobileOpen);
              }
            }}
          >
            <span className="hamburger-box">
              <span className="hamburger-inner"></span>
            </span>
          </button>

          <div className={classes.logo}>

            <Link className='logolink' to='/'>
              <img src="/img/logo/w.svg" alt="logo" />
            </Link>
          </div>
        </Toolbar>
      </AppBar>

      <nav aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper
            }}
            ModalProps={{
              keepMounted: true // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      {/*  <Content /> */}
    </div>
  );
}

Menu.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  container: PropTypes.instanceOf(
    typeof Element === "undefined" ? Object : Element
  )
};
